import React from 'react';
import { motion } from 'motion/react';
import ThreadHistoryPanel from './ThreadHistoryPanel';
import ChatMessage from './ChatMessage';
import { VANTI_NOT_CONFIGURED_MESSAGE } from '../../utils/aiSetupHelp';

export default function AIChatMessageList({
  listRef,
  threadsOpen,
  threads,
  threadsLoading,
  onCloseThreads,
  onSelectThread,
  onDeleteThread,
  onCooldown,
  cooldownRemainingMs,
  lastSendPayload,
  onRetryLast,
  loading,
  messages,
  disabledByOrg,
  configured,
  streamingMessageId,
  streamingStatus,
  feedbackState,
  copiedResponseId,
  reduceMotion,
  onFeedback,
  onCopyResponse,
  onAnswer,
  onScopeSelect,
  onInlineScopeSelect,
  onNavigate,
  onModeChange,
  onSetInput,
  onFollowUp,
  onRetryFailed,
}: any) {
  return (
    <div ref={listRef} className="relative min-h-0 flex-1 space-y-4 overflow-y-auto p-4">
      <ThreadHistoryPanel
        open={threadsOpen}
        threads={threads}
        loading={threadsLoading}
        onClose={onCloseThreads}
        onSelectThread={onSelectThread}
        onDeleteThread={onDeleteThread}
      />
      {onCooldown ? (
        <motion.div
          layout={false}
          className="rounded-lg border-amber-900/40 bg-amber-900/20 px-3 py-2 text-amber-200"
        >
          Rate limited. You can retry in {Math.ceil(cooldownRemainingMs / 1000)}s.
          {lastSendPayload ? (
            <button
              type="button"
              className="ml-2 underline"
              onClick={onRetryLast}
              disabled={onCooldown || loading}
            >
              Retry
            </button>
          ) : null}
        </motion.div>
      ) : null}
      {messages.length === 0 && !loading && (
        <div className="py-8 text-center text-sm text-slate-500">
          {disabledByOrg ? (
            <p>Vanti chat is disabled for your organisation.</p>
          ) : configured === false ? (
            <p>{VANTI_NOT_CONFIGURED_MESSAGE}</p>
          ) : (
            <>
              <p className="mb-1 font-medium text-slate-300">
                Meet Vanti, your VantagePoint guide.
              </p>
              <p>Ask about your repos, PRs, branches, or Git & GitHub in general.</p>
            </>
          )}
        </div>
      )}
      {messages.map((m) => (
        <ChatMessage
          key={m.id || `${m.role}-${m.content?.slice(0, 20)}`}
          message={m}
          loading={loading}
          feedbackState={feedbackState}
          copiedResponseId={copiedResponseId}
          reduceMotion={reduceMotion}
          streamingStatus={m.id === streamingMessageId ? streamingStatus : ''}
          onFeedback={onFeedback}
          onCopyResponse={onCopyResponse}
          onAnswer={onAnswer}
          onScopeSelect={onScopeSelect}
          onInlineScopeSelect={onInlineScopeSelect}
          onNavigate={onNavigate}
          onModeChange={onModeChange}
          onSetInput={onSetInput}
          onFollowUp={onFollowUp}
          onRetryFailed={onRetryFailed}
        />
      ))}
    </div>
  );
}
